export default typeof window === 'undefined' ? require('./get-server-host')["default"] : require('./get-client-host')["default"];